<form class="h-100" [formGroup]="locationCodeForm" autocomplete="off">
  <div class="d-flex flex-column h-100">
    <div class="gx-3 row">
      <div class="col-sm-6 mb-3">
        <input-field
          [label]="'Location Code'"
          [type]="'text'"
          [placeholder]="'Enter Location Code'"
          formControlName="locationCode"
          [requiredLabel]="true"
          [errormessage]="'Location Code is required'"
        >
        </input-field>
      </div>
      <div class="col-sm-6 mb-3">
        <input-field
          [label]="'Location Name'"
          [type]="'text'"
          [placeholder]="'Enter Location Name'"
          formControlName="locationName"
          [requiredLabel]="true"
          [errormessage]="'Location Name is required'"
        >
        </input-field>
      </div>
    </div>
    @if (selectedLocationCodeId()) {
      <div class="col-sm-6 mb-3">
        <div class="d-flex align-items-center gap-3">
          <p class="mb-1 fs-16">In Active</p>
          <p-toggleswitch formControlName="inActive" class="lh-1" />
        </div>
      </div>
    }
  </div>
</form>
